<template>
  <div class="category-list-area-wrapper">
    <div class="category-list-area">
      <div class="category-list-area__title">
        {{ $t("LandingPage.selectBox") }}
      </div>
      <div
        class="category-list-area__list"
        v-for="(category, i) in CategoryLists"
        :key="i"
        :class="[
          Object.keys(CategoryLists).indexOf(i) == 0 ? 'first-child' : '',
        ]"
        v-show="true"
      >
      <!-- request DA team change category for whole language-->
      <!-- v-show="$i18n.locale == 'ko'  || ($i18n.locale != 'ko' && !(category.title == 'Vacuums' || category.title == 'Air Solutions'|| category.title == 'Kitchen'|| category.title == 'Refrigerator'))" -->
        
            <h3 class="category-list-area__list__title">{{ category.title }}</h3>
            <!-- <div class="swiper-area-wrapper"> -->
            <template v-if="Object.keys(category.list).length > 3">
              <swiper ref="mySwiper" :options="swiperOptionsDesktop">
                <swiper-slide v-for="(list, i) in category.list" :key="i"
                v-show="!($i18n.locale != 'ko' && (list == category.list.BespokeSlimCleanStation || list == category.list.BespokeSlim))">
                  <CategoryList :category="list" :key="i"></CategoryList>
                </swiper-slide>
              </swiper>
            </template>
            <template v-else>
              <CategoryList
                v-for="(list, i) in category.list"
                :key="i"
                :category="list"
              ></CategoryList>
            </template>
      </div>
      <div
        class="category-list-area__list mobile"
        v-for="(category, i) in CategoryLists"
        :class="[
          Object.keys(CategoryLists).indexOf(i) == 0 ? 'first-child' : '',
        ]"
        :key="100 + i"
        v-show="true"
      >
      <!-- v-show="$i18n.locale == 'ko'  || ($i18n.locale != 'ko' && !(category.title == 'Vacuums' || category.title == 'Air Solutions'|| category.title == 'Kitchen'|| category.title == 'Refrigerator'))" -->
        <h3 class="category-list-area__list__title">{{ category.title }}</h3>
        <swiper ref="mySwiper" :options="swiperOptionsMobile">
          <swiper-slide v-for="(list, i) in category.list" :key="i">
            <CategoryList :category="list"></CategoryList>
          </swiper-slide>
        </swiper>
      </div>
      <a
        class="category-list-area__button route-button right"
        :href="$t('LandingPage.moreActivityLink')" target='_blank'
        v-html="$t('LandingPage.moreActivity')"
      />
    </div>
  </div>
</template>

<script>
//  :href=$t('LandingPage.moreActivityLink')
import { routePaths } from "@/models/RoutePath";
import { CategoryLists } from "@/models/CategoryKey";
import * as easing from "eases/quart-in-out";
// import OverDriveKey from "@/models/overdrive/Landing_Category";
import CategoryList from "./CategoryList/CategoryList";


export default {
  
  data() {
    return {
      // OverDriveKey,
      easing,
      routePaths,
      CategoryLists,
      swiperOptionsMobile: {
        spaceBetween: 30,
        slidesPerView: "auto",
        // breakpoints: {
        //   510: {
        //     slidesPerView: "auto",
        //     spaceBetween: 30,
        //   },
        // },
      },
      swiperOptionsDesktop: {
        slidesPerView: "auto",
        spaceBetween: 60,
        breakpoints: {
          1100: {
            slidesPerView: "auto",
            spaceBetween: 30,
          },
        },
      },
      link: undefined,
    };
  },
  components: {
    CategoryList,
  },
  methods: {
    log(v, i) {
      console.log(v);
      console.log(i);
    },
  },
  created() {
    //console.log(this.link, this.$i18n.locale);
    this.link =
      this.$i18n.locale === "ko"
        ? "http://csrsamsung.com/environment.html"
        : "https://www.samsung.com/us/aboutsamsung/sustainability/environment/responsible-recycling/";
  },
  // mounted() {
  //   this.$nextTick(() => {
  //     // console.log(this.$refs.itemImages);
  //     objectFitImages([this.$refs.itemImages1]);
  //   });
  // },
};
</script>

<style scoped>
.category-list-area-wrapper {
  text-align: center;
  background-color: #111111;
  color: white;
  width: 100%;
  overflow-x: hidden;
}
.category-list-area {
  max-width: 1200px;
  margin: auto;
}
.category-list-area__list {
  position: relative;
  padding-top: 8rem;
  margin-top: 150px;
  /* justify-content: space-between; */
}
.category-list-area__list.first-child {
  margin-top: 120px;
}
.swiper-container {
  margin: 0;
  width: 100%;
  height: 100%;
  overflow: unset;
}
.swiper-wrapper {
  width: auto;
}
.swiper-area-wrapper {
  margin-top: 20px;
}
.swiper-slide {
  max-width: 360px;
  width: 22vw;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}
.category-list-area__list__title {
  position: absolute;
  top: 2px;
  left: 0;
  margin: 0;
  font-size: 2.9rem;
  font-weight: bold;
  color: #f5f5f5;
  font-weight:500;
}
.category-list-area__title {
  font-size: 2.9rem;
  font-weight: 700;
  padding: 7.8rem 0 0;
}

.category-list-area__item figure {
  height: 250px;
  display: flex;
  align-items: center;
  justify-content: center;
}
/* .category-list-area__item img {
  top: 50%;
} */
.category-list-area__item caption {
  margin-top: 50px;
  font-size: 2.3rem;
  font-weight: 700;
  width: 100%;
  display: inline-block;
  white-space: nowrap;
}
.category-list-area__button {
  padding: 25px 50px;
  border: 2px solid #aaaaaa;
  border-radius: 50px;
  display: inline-block;
  font-weight: 500;
  font-size: 1.5rem;
  text-align: center;
  margin: 150px 0;
}

.category-list-area__list-mobile {
  display: none;
}
@media (max-width: 1200px) {
  /* .swiper-slide {
    width: 300px !important;
  } */
  .swiper-slide {
    width: 25vw;
  }
  .category-list-area__list.mobile {
    margin-top: 90px;
  }
  .category-list-area__list {
    margin-left: 20px;
    margin-right: 20px;
  }
}

@media (max-width: 1100px) {
  .swiper-slide {
    width: 25vw;
  }
}

@media (max-width: 1023px) {
  .category-list-area__button {
    font-size: 0.8rem;
    /* padding: 0.5rem 0; */
    padding: 0.5rem;
    padding-right: 25px;
    padding-left: 25px;
    width: 210px;
  }
}

@media (max-width: 810px) {
  .category-list-area__list-mobile {
    display: block;
  }

  .category-list-area__list-mobile.first-child {
    margin-top: 90px;
  }
  .category-list-area__list {
    display: none;
  }
  .swiper-slide {
    width: 204px;
  }
}

@media (max-width: 767px) {
  .category-list-area__title {
    font-size: 1.84rem;
    font-weight: 700;
    padding: 6.9vw 0;
  }

  .category-list-area-mobile::-webkit-scrollbar {
    display: none !important;
  }
  .category-list-area-mobile::-webkit-scrollbar-track {
    display: none !important;
    width: 0;
    height: 0;
    padding: 0;
  }
  .category-list-area__list-mobile .category-list-area__item {
    display: flex;
    width: 208px;
    box-sizing: border-box;
    max-height: 270px;
    border-radius: 20px;
    /* margin-left: 15px; */
    padding: 48px 40px 31px 40px;
    margin: 0;
    /* height: 100%; */
    justify-content: space-between;
    flex-direction: column;
    align-items: center;
    flex-grow: 0;
    flex-shrink: 0;
    text-decoration: none;
  }

  .mobile {
    display: block;
  }

  .indicator-list {
    display: flex;
    justify-content: center;
    background-color: black !important;
    width: 78px;
    justify-content: space-evenly;
    padding: 6px 0px;
    margin: auto;
    border-radius: 8px;
    /* height: 18px; */
    margin-top: 15px;
  }
  .indicator-list
    >>> .swiper-pagination-bullet.swiper-pagination-bullet-active {
    background-color: white !important;
  }
  .indicator-list >>> .swiper-pagination-bullet {
    background-color: #aaaaaa !important;
  }
  .indicator-list .indicator {
    width: 6px;
    height: 6px;
    border-radius: 50%;
  }

  .indicator-list .indicator.active {
    background-color: white;
  }
}

@media (max-width: 500px) {
  .category-list-area__button {
    margin: 90px 0;
  }
  .category-list-area__list.mobile {
    padding-top: 5rem;
    margin-top: 90px;
  }

  .category-list-area__list.mobile.first-child {
    margin-top: 32px;
  }
  .category-list-area__list__title {
    font-size: 1.7rem;
  }
}
@media (max-width: 499px) {
  .swiper-slide {
    width: 50vw;
  }
}

@media (min-width: 768px) {
  .category-list-area__list {
    display: -webkit-box;
    display: -ms-flexbox;
    overflow-x: visible;
  }

  .category-list-area__item figure {
    height: 19.3vw;
  }
  .category-list-area__item img {
    width: 100%;
    height: 19.3vw;
    max-height: 250px;
    display: inline-block;
    object-fit: contain;
    font-family: "object-fit: contain;";
  }
  .category-list-area__list.mobile {
    display: none;
  }
}
@media (min-width: 1024px) {
  .category-list-area__button.route-button {
    width: 881px;
    box-sizing: border-box;
    font-size: 24px;
  }
}

.category-list-area__list-mobile::-webkit-scrollbar {
  display: none;
  height: 0;
}
</style>
